<div class="body" (window:beforeunload)="onBeforeUnload()">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Pre-Quote Contract Conversion</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <!-- <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" (click)="GoToCreate($event)"
                                        class="p-button-success p-mr-2"></button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                    title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                    tooltipPosition="bottom"  (click)="exportExcel()"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                <p-table #dt [value]="ContractConversionCustomersList" [rows]="10" [paginator]="true" [columns]="cols"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['customername','tallyid','companytype','istransporter','pan','billingcycle','recordstatus']"
                                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                 [showCurrentPageReport]="true">
                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:100px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="customername">Customer Name <p-sortIcon field="customername"></p-sortIcon>
                                        </th>
                                        <!-- <th pSortableColumn="tallyid">Customer Tally ID <p-sortIcon field="tallyid">
                                            </p-sortIcon>
                                        </th> -->
                                        <th pSortableColumn="companytype">Company Type <p-sortIcon field="companytype">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="istransporter">Is Transporter <p-sortIcon field="istransporter">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="pan">PAN No <p-sortIcon field="pan">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="billingcycle">Billing Cycle <p-sortIcon field="billingcycle">
                                            </p-sortIcon>
                                        </th>
                                        <th style="width:150px;text-align: center;" pSortableColumn="recordstatus">Action <p-sortIcon field="recordstatus"></p-sortIcon>
                                        </th>
                                        <!-- <th pSortableColumn="mobileNo">State <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo">
                                            </p-sortIcon>
                                        </th> -->
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList>
                                    <tr>
                                        <td>
                                            {{_ManageCustomerList.customername}}
                                        </td>
                                        <!-- <td>
                                            {{_ManageCustomerList.tallyid}}
                                        </td> -->
                                        <td>
                                            {{_ManageCustomerList.companytype}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.istransporter}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.pan}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.billingcycle}}
                                        </td>
                                        <td style="text-align: center;">
                                            <button pButton pRipple title="View" icon="las la-eye"
                                                class="p-button p-button p-mr-2" (click)="ViewContractConversion(_ManageCustomerList)"
                                                >
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast position="bottom-right"></p-toast>
